import React, { useRef, useState, useEffect } from 'react';
import { C } from '../utils/theme.js';
import { addDarkBasemap } from '../utils/mapTiles.js';

export default function MapView(props) {
  var qsos = props.qsos;
  var stats = props.stats;
  var compact = props.compact;
  var ref = useRef(null);
  var mapRef = useRef(null);
  var readyState = useState(false);
  var ready = readyState[0];
  var setReady = readyState[1];

  useEffect(function() {
    if (document.getElementById("lf-css")) {
      setReady(!!window.L);
      return;
    }
    var css = document.createElement("link");
    css.id = "lf-css";
    css.rel = "stylesheet";
    css.href = "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css";
    document.head.appendChild(css);
    var js = document.createElement("script");
    js.src = "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js";
    js.onload = function() { setReady(true); };
    document.head.appendChild(js);
  }, []);

  useEffect(function() {
    if (!ready || !ref.current || !window.L) return;
    if (mapRef.current) {
      mapRef.current.remove();
      mapRef.current = null;
    }
    // Guard against corrupt data: never feed non-finite coordinates to Leaflet
    // (a single Invalid LatLng throw would otherwise blank the whole app).
    var isNum = function(n) { return typeof n === "number" && isFinite(n); };
    var myLat = isNum(stats && stats.myLat) ? stats.myLat : -14.24;
    var myLon = isNum(stats && stats.myLon) ? stats.myLon : -51.93;
    try {
      var map = window.L.map(ref.current, {
        preferCanvas: true,
        zoomControl: !compact
      }).setView([myLat, myLon], 2);
      mapRef.current = map;

      addDarkBasemap(map, { maxZoom: 18 });

      var myIcon = window.L.divIcon({
        html: '<div style="width:14px;height:14px;background:' + C.a3 +
          ';border:2px solid #fff;border-radius:50%;box-shadow:0 0 10px ' +
          C.a3 + '"></div>',
        className: "",
        iconSize: [14, 14],
        iconAnchor: [7, 7]
      });
      window.L.marker([myLat, myLon], { icon: myIcon })
        .addTo(map).bindPopup("<b>MY QTH</b>");

      var withC = qsos.filter(function(q) { return q && isNum(q.lat) && isNum(q.lon); });
      var step = withC.length > 4000 ? Math.ceil(withC.length / 4000) : 1;
      for (var i = 0; i < withC.length; i += step) {
        var q = withC[i];
        window.L.polyline(
          [[myLat, myLon], [q.lat, q.lon]],
          { color: C.a1, weight: 0.5, opacity: 0.25 }
        ).addTo(map);
        var popupHtml = '<div style="font-family:monospace;font-size:12px">' +
          '<b style="color:' + C.a2 + '">' + q.call + '</b><br/>' +
          q.entity + '<br/>' + q.band + ' ' + q.mode + '<br/>' +
          (q.time ? q.time.substring(0, 2) + ':' + q.time.substring(2, 4) + ' UTC' : '-') +
          '<br/>' +
          (q.distance ? Math.round(q.distance).toLocaleString() + ' km' : '-') +
          '</div>';
        window.L.circleMarker([q.lat, q.lon], {
          radius: compact ? 2 : 3,
          color: C.a2, fillColor: C.a2,
          fillOpacity: 0.6, weight: 0
        }).addTo(map).bindPopup(popupHtml);
      }
      setTimeout(function() { try { map.invalidateSize(); } catch (e) {} }, 300);
    } catch (e) {
      // Never let a map rendering error take down the whole dashboard.
      console.error("MapView render error:", e);
    }
    return function() {
      if (mapRef.current) {
        try { mapRef.current.remove(); } catch (e) {}
        mapRef.current = null;
      }
    };
  }, [ready, qsos, stats, compact]);

  return React.createElement("div", {
    ref: ref,
    style: {
      width: "100%",
      height: compact ? 350 : 550,
      background: C.bg,
      borderRadius: 12,
      border: "1px solid " + C.bd
    }
  });
}
